import { defineComponent } from "~/utils/define-component";

function parse(form: HTMLFormElement) {
  const formData = new FormData(form);
  const [id] = formData.getAll("id");
  const quantity = parseInt(formData.getAll("quantity").toString() || "1");

  return {
    id: parseInt(id.toString()),
    quantity,
  };
}

export default defineComponent(() => ({
  async handleSubmit(e: SubmitEvent) {
    const form = (e.target as HTMLElement).closest("form");

    if (!form) return;

    const data = parse(form);

    window.dispatchEvent(new CustomEvent("update-cart", { detail: data }));
  },
}));
